<template>
    <az-call-to-action dark
                       @click="acessarAreaPublica(licitacao)">
        ÁREA PÚBLICA
    </az-call-to-action>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'LicitacaoAtualizacaoAcoesAreaPublica',
        computed: {
            ...mapState(['licitacao'])
        },
        methods: {
            acessarAreaPublica(licitacao) {
                const hostname = window.location.hostname
                const url = `${window.location.protocol}//${hostname}/licitacao-pub/#/licitacao-visualizacao/${licitacao.id}/dados-gerais`
                window.open(url, '_blank')
            }
        }
    }
</script>
